import * as modules from './modules'

export default modules
